// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"BusinessSection_main-wrapper__tZCAp","content-wrapper":"BusinessSection_content-wrapper__XxUrs"};